import { RoomTranscriptionRow } from '../../../shared/services/transcriber.service';
import { CrLyaLiveNote, IARTSuggestion, JoinEvent, LiveRecruterScoresData } from './meetcall.types';

export class MeetCallActions {
  static readonly anonyme = class {
    static readonly type = '[meetcall] anonyme action';
  };
  static readonly setRoomTranscription = class {
    static readonly type = '[meetcall] set room transcription';
    constructor(public roomTranscription: RoomTranscriptionRow[]) {}
  };

  static readonly joinMeetCall = class {
    static readonly type = '[meetcall] join meet call';
    constructor(public data: JoinEvent) {}
  };

  static readonly setCandidatScores = class {
    static readonly type = '[meetcall] set candidat scores';
    constructor(public data: LiveRecruterScoresData) {}
  };

  static readonly saveSuggestion = class {
    static readonly type = '[meetcall] save suggestion';
    constructor(public data: IARTSuggestion) {}
  };

  static readonly clearSuggestion = class {
    static readonly type = '[meetcall] clear suggestion';
  };

  static readonly saveComment = class {
    static readonly type = '[meetcall] save event comment';
    constructor(public data: CrLyaLiveNote) {}
  };
  static readonly setLinkData = class {
    static readonly type = '[meetcall] set link data';
    constructor(public data: string) {}
  };
}
